import React from "react";
import { FlexRowBetween } from "../Style";

const Names = (props) => {
  const heartColor = props.heartColor || "#6b7c5e";

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-start",
    padding: "16px 16px 12px",
    gap: "8px",
  };

  const cardStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "10px 18px",
    borderRadius: "12px",
    background: "rgba(255,255,255,0.5)",
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    border: "1px solid rgba(0,0,0,0.05)",
    boxSizing: "border-box",
  };

  const iconWrap = {
    width: "22px",
    height: "22px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const iconWrapSmall = {
    width: "18px",
    height: "18px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const IconDate = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={heartColor}
      strokeWidth="1.85"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );

  const IconLocation = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={heartColor}
      strokeWidth="1.85"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
      <circle
        cx="12"
        cy="9"
        r="2.5"
        stroke={heartColor}
        fill="none"
        strokeWidth="1.85"
      />
    </svg>
  );

  const dateStr = props.data.date
    .replace(/T.*/, "")
    .split("-")
    .reverse()
    .join("/");
  const locationStr = "״" + props.data.hall + "״," + " " + props.data.city;

  return (
    <div style={containerStyle}>
      {props.data.eventType ? (
        <FlexRowBetween
          style={{ justifyContent: "center", flexWrap: "wrap", gap: "4px" }}
        >
          <span
            style={{
              fontFamily: "'David Libre', serif",
              fontSize: "clamp(26px, 6vw, 34px)",
              fontWeight: "500",
              letterSpacing: "0.02em",
              color: "#2c2c2c",
            }}
          >
            {props.data.brideFN}
          </span>
          <span
            style={{
              margin: "0 10px",
              color: heartColor,
              fontFamily: "dar",
              fontSize: "clamp(28px, 5vw, 36px)",
              fontWeight: "700",
              lineHeight: 1.2,
            }}
          >
            &
          </span>
          <span
            style={{
              fontFamily: "'David Libre', serif",
              fontSize: "clamp(26px, 6vw, 34px)",
              fontWeight: "500",
              letterSpacing: "0.02em",
              color: "#2c2c2c",
            }}
          >
            {props.data.groomFN}
          </span>
        </FlexRowBetween>
      ) : (
        <div
          style={{
            fontFamily: "rub",
            fontSize: "20px",
            fontWeight: "700",
            textAlign: "center",
            padding: "10px",
            color: "#2c2c2c",
          }}
        >
          {props.data.calendarName}
        </div>
      )}

      <div style={cardStyle}>
        <div style={iconWrapSmall}>
          <IconDate />
        </div>
        <div
          style={{
            fontFamily: "rub",
            fontSize: "14px",
            fontWeight: "400",
            color: "#5a5a5a",
            letterSpacing: "0.01em",
          }}
        >
          {dateStr}
        </div>
      </div>

      <div style={cardStyle}>
        <div style={iconWrap}>
          <IconLocation />
        </div>
        <div
          style={{
            fontFamily: "rub",
            fontSize: "14px",
            color: "#5a5a5a",
            letterSpacing: "0.01em",
          }}
        >
          {locationStr}
        </div>
      </div>
    </div>
  );
};

export default Names;
